export default __webpack_public_path__ + "static/media/edit-paste.ee0e174b.png";